import { render, staticRenderFns } from "./CircleLiveDetail.vue?vue&type=template&id=223a90b0&scoped=true"
import script from "./CircleLiveDetail.vue?vue&type=script&lang=js"
export * from "./CircleLiveDetail.vue?vue&type=script&lang=js"
import style0 from "./CircleLiveDetail.vue?vue&type=style&index=0&id=223a90b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223a90b0",
  null
  
)

export default component.exports